export const questionDourceRelationTypeColorOrder: Record<
  string,
  { textColor: string; bgColor: string }
> = {
  Similar_DiffQLogic: {
    textColor: '#1b5791',
    bgColor: '#bfe2f4',
  },
  Repeat_DiffNames: {
    textColor: '#894c12',
    bgColor: '#ffc8a6',
  },
  Repeat_Variant: {
    textColor: '#765631',
    bgColor: '#ffe6a1',
  },
  Repeat_Identical: {
    textColor: '#b13a1f',
    bgColor: '#ffcec8',
  },
  Similar_SameQLogic: {
    textColor: '#2e6f4e',
    bgColor: '#d4eebc',
  },
  Related_Topic: {
    textColor: '#797979',
    bgColor: '#e8eaee',
  },
};
